"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _CActions = _interopRequireDefault(require("01_core/components/materials/CActions"));
var _CButton = _interopRequireDefault(require("01_core/components/materials/CButton"));
var _CTextField = _interopRequireDefault(require("01_core/components/materials/CTextField"));
var _labelConsts = require("01_core/constants/labelConsts");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
var _Consts = require("../../common/consts/Consts");
var _ReportListTable = _interopRequireDefault(require("./ReportListTable"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const NAME_CELL_WIDTH = 130;
const NUM_CELL_WIDTH = 100;
const COLOR_GOOD = '#0000FF';
const COLOR_NORMAL = '#000000';
const COLOR_BAD = '#FF0000';
const NameCell = (0, _styles.styled)(_material.TableCell)({
  width: NAME_CELL_WIDTH,
  borderBottom: 'solid 1px',
  padding: 0
});
const NumCell = (0, _styles.styled)(_material.TableCell)({
  width: NUM_CELL_WIDTH,
  borderBottom: 'solid 1px',
  paddingRight: '3px'
});
const MetricText = (0, _styles.styled)(_material.Typography)({
  fontSize: 'small',
  fontWeight: 'bold',
  textAlign: 'right'
});

/**
 * 訓練実施報告登録：BCP訓練チェックシート集計結果
 */
class ChecksheetSummaryResultField extends _react.default.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "calcAverage", reportResultList => {
      let replyNumSumU = 0; // 回答数（理解度用）
      let replyNumSumE = 0; // 回答数（有効性用）
      let understandSum = 0; // 理解度
      let effectSum = 0; // 有効性
      let understandAverage = 0;
      let effectAverage = 0;
      reportResultList.forEach(item => {
        if (!item.replyNum || isNaN(item.replyNum)) {
          // 回答数が設定されていない場合は集計対象外
          return;
        }
        const replyNum = Number(item.replyNum);
        const understand = Number(item.understand);
        const effect = Number(item.effect);

        // 理解度加算
        if (item.understand && !isNaN(item.understand)) {
          replyNumSumU += replyNum;
          understandSum += replyNum * understand;
        }
        // 有効性加算
        if (item.effect && !isNaN(item.effect)) {
          replyNumSumE += replyNum;
          effectSum += replyNum * effect;
        }
      });
      if (understandSum !== 0) {
        understandAverage = understandSum / replyNumSumU;
      }
      if (effectSum !== 0) {
        effectAverage = effectSum / replyNumSumE;
      }
      this.props.setEntry('reportResultAverage')(_objectSpread(_objectSpread({}, this.props.reportEntry.reportResultAverage), {}, {
        understand: understandAverage === 0 ? '' : understandAverage.toFixed(2),
        effect: effectAverage === 0 ? '' : effectAverage.toFixed(2)
      }));
    });
    // 入力時
    _defineProperty(this, "changeReportReslt", (rowIndex, key) => value => {
      const list = this.props.reportEntry.reportResultList.slice();
      const row = list[rowIndex];
      list[rowIndex] = _objectSpread(_objectSpread({}, row), {}, {
        [key]: value
      });
      this.props.setEntry('reportResultList')(list);
      this.props.setList(list);
      if (key === 'replyNum' || key === 'understand' || key === 'effect') {
        this.calcAverage(list);
      }
    });
    // チーム追加ボタン押下時
    _defineProperty(this, "onAddClick", () => {
      const list = this.props.reportEntry.reportResultList.slice();
      list.push({
        resultNo: list.length + 1,
        teamName: '',
        replyNum: '',
        understand: '',
        effect: '',
        teamComment: ''
      });
      this.props.setEntry('reportResultList')(list);
      this.props.setList(list);
    });
    _defineProperty(this, "fontColor", num => {
      const val = Number(num);
      if (!isNaN(val) && val >= _Consts.CONSTS.GOOD_VAL) {
        return COLOR_GOOD;
      } else if (!isNaN(val) && val <= _Consts.CONSTS.NORMAL_VAL) {
        return COLOR_BAD;
      } else {
        return COLOR_NORMAL;
      }
    });
  }
  render() {
    const {
      intl,
      reportEntry,
      errors
    } = this.props;
    const columns = [{
      dataKey: 'teamName',
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_CHECKSHEET_TEAM_NM
      }),
      width: 700
    }, {
      dataKey: 'replyNum',
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_CHECKSHEET_REPLY
      }),
      width: 150
    }, {
      dataKey: 'understand',
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_CHECKSHEET_UNDERSTAND
      }),
      width: 150
    }, {
      dataKey: 'effect',
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_CHECKSHEET_EFFECT
      }),
      width: 150
    }, {
      dataKey: 'teamComment',
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_CHECKSHEET_COMMENT
      }),
      width: 850
    }];

    // 被監査部門表データ
    const createRow = (data, rowIndex) => {
      var _rowErrors$teamName, _data$replyNum, _rowErrors$replyNum, _data$understand, _rowErrors$understand, _data$effect, _rowErrors$effect, _rowErrors$teamCommen;
      const rowErrors = Array.isArray(errors === null || errors === void 0 ? void 0 : errors.reportResultList) ? errors.reportResultList[rowIndex] : undefined;
      const teamName = /*#__PURE__*/_react.default.createElement(_CTextField.default, {
        value: data.teamName,
        onChange: this.changeReportReslt(rowIndex, 'teamName'),
        maxLength: 20,
        error: !!(rowErrors !== null && rowErrors !== void 0 && rowErrors.teamName),
        helperText: rowErrors === null || rowErrors === void 0 || (_rowErrors$teamName = rowErrors.teamName) === null || _rowErrors$teamName === void 0 ? void 0 : _rowErrors$teamName.message
      });
      const replyNum = /*#__PURE__*/_react.default.createElement(_CTextField.default, {
        value: String((_data$replyNum = data.replyNum) !== null && _data$replyNum !== void 0 ? _data$replyNum : ''),
        onChange: this.changeReportReslt(rowIndex, 'replyNum'),
        maxLength: 5,
        inputProps: {
          style: {
            textAlign: 'right'
          }
        },
        error: !!(rowErrors !== null && rowErrors !== void 0 && rowErrors.replyNum),
        helperText: rowErrors === null || rowErrors === void 0 || (_rowErrors$replyNum = rowErrors.replyNum) === null || _rowErrors$replyNum === void 0 ? void 0 : _rowErrors$replyNum.message
      });
      const understand = /*#__PURE__*/_react.default.createElement(_CTextField.default, {
        value: String((_data$understand = data.understand) !== null && _data$understand !== void 0 ? _data$understand : ''),
        onChange: this.changeReportReslt(rowIndex, 'understand'),
        maxLength: 4,
        inputProps: {
          style: {
            textAlign: 'right'
          }
        },
        error: !!(rowErrors !== null && rowErrors !== void 0 && rowErrors.understand),
        helperText: rowErrors === null || rowErrors === void 0 || (_rowErrors$understand = rowErrors.understand) === null || _rowErrors$understand === void 0 ? void 0 : _rowErrors$understand.message
      });
      const effect = /*#__PURE__*/_react.default.createElement(_CTextField.default, {
        value: String((_data$effect = data.effect) !== null && _data$effect !== void 0 ? _data$effect : ''),
        onChange: this.changeReportReslt(rowIndex, 'effect'),
        maxLength: 4,
        inputProps: {
          style: {
            textAlign: 'right'
          }
        },
        error: !!(rowErrors !== null && rowErrors !== void 0 && rowErrors.effect),
        helperText: rowErrors === null || rowErrors === void 0 || (_rowErrors$effect = rowErrors.effect) === null || _rowErrors$effect === void 0 ? void 0 : _rowErrors$effect.message
      });
      const teamComment = /*#__PURE__*/_react.default.createElement(_CTextField.default, {
        value: data.teamComment,
        onChange: this.changeReportReslt(rowIndex, 'teamComment'),
        maxLength: 1000,
        multiline: true,
        rows: 2,
        error: !!(rowErrors !== null && rowErrors !== void 0 && rowErrors.teamComment),
        helperText: rowErrors === null || rowErrors === void 0 || (_rowErrors$teamCommen = rowErrors.teamComment) === null || _rowErrors$teamCommen === void 0 ? void 0 : _rowErrors$teamCommen.message
      });
      return {
        teamName,
        replyNum,
        understand,
        effect,
        teamComment
      };
    };
    const pushButton = /*#__PURE__*/_react.default.createElement(_CButton.default, {
      autoWidth: true,
      onClick: this.onAddClick
    }, intl.formatMessage({
      id: _labelConsts.LABEL.BCM_KUNREN_CHECKSHEET_TEAM_ADD
    }));
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ReportListTable.default, {
      rowData: reportEntry.reportResultList,
      columns,
      createRow
    }), /*#__PURE__*/_react.default.createElement(_material.Table, null, /*#__PURE__*/_react.default.createElement(_material.TableBody, null, /*#__PURE__*/_react.default.createElement(_material.TableRow, null, /*#__PURE__*/_react.default.createElement(_material.TableCell, {
      style: {
        width: 800
      }
    }), /*#__PURE__*/_react.default.createElement(NameCell, null, /*#__PURE__*/_react.default.createElement(MetricText, null, intl.formatMessage({
      id: _labelConsts.LABEL.BCM_KUNREN_CHECKSHEET_AVERAGE
    }))), /*#__PURE__*/_react.default.createElement(NumCell, null, /*#__PURE__*/_react.default.createElement(MetricText, {
      style: {
        color: this.fontColor(reportEntry.reportResultAverage.understand)
      }
    }, reportEntry.reportResultAverage.understand)), /*#__PURE__*/_react.default.createElement(NumCell, null, /*#__PURE__*/_react.default.createElement(MetricText, {
      style: {
        color: this.fontColor(reportEntry.reportResultAverage.effect)
      }
    }, reportEntry.reportResultAverage.effect)), /*#__PURE__*/_react.default.createElement(_material.TableCell, {
      style: {
        width: 950,
        maxWidth: 1100
      }
    })), /*#__PURE__*/_react.default.createElement(_material.TableRow, null, /*#__PURE__*/_react.default.createElement(_material.TableCell, {
      style: {
        width: 800
      }
    }), /*#__PURE__*/_react.default.createElement(NameCell, null, /*#__PURE__*/_react.default.createElement(MetricText, null, intl.formatMessage({
      id: _labelConsts.LABEL.BCM_KUNREN_CHECKSHEET_PREVIOUS
    }))), /*#__PURE__*/_react.default.createElement(NumCell, null, /*#__PURE__*/_react.default.createElement(MetricText, {
      style: {
        color: this.fontColor(reportEntry.reportResultPrevious.understand)
      }
    }, reportEntry.reportResultPrevious.understand)), /*#__PURE__*/_react.default.createElement(NumCell, null, /*#__PURE__*/_react.default.createElement(MetricText, {
      style: {
        color: this.fontColor(reportEntry.reportResultPrevious.effect)
      }
    }, reportEntry.reportResultPrevious.effect)), /*#__PURE__*/_react.default.createElement(_material.TableCell, {
      style: {
        width: 950,
        maxWidth: 1100
      }
    })))), /*#__PURE__*/_react.default.createElement(_CActions.default, {
      actions: [pushButton]
    }));
  }
}
var _default = exports.default = (0, _reactIntl.injectIntl)(ChecksheetSummaryResultField);